import React from 'react'
import classnames from 'classnames/bind'
import { images } from '../../../../../images/exported'
import styles from '../index.scss'
import { watermarkTypes } from '../../../../../constants'

const cx = classnames.bind(styles)

const ImageWatermark = ({ type }: { type?: keyof typeof watermarkTypes }) => {
  let targetImage
  switch (type) {
    case watermarkTypes.SmartSale:
      targetImage = images.smartsaleOverlay
      break
    default:
      targetImage = null
  }
  if (!targetImage) {
    return null
  }
  return (
    <div className={cx('watermark-container')}>
      <div
        className={cx('watermark-image')}
        style={{ backgroundImage: `url(${targetImage})` }}
      />
    </div>
  )
}

export default ImageWatermark
